// extracted by mini-css-extract-plugin
export default {"wrap":"nF-z","articleImagesWrap":"oF-z","articleImage":"pF-z","singleImage":"qF-z"};